import { SystemService, SystemProvider, SystemActionsProvider, HttpService } from '@lk/api'

export const makeSystemService = (http: HttpService, baseUrl: string) =>
  new SystemService(new SystemProvider(http, baseUrl), new SystemActionsProvider(http, baseUrl))
